module.exports = __webpack_public_path__ + "static/media/minnesota_logo.01e22a0f.png";